module.exports = __webpack_public_path__ + "media/images/sort_both-9a648608.png";